const REVIEW_STATUS_LANGUAGE = {
    open: { label: "待审核", color: "gold" },
    under_review: { label: "审核中", color: "processing" },
    needs_rebase: { label: "需刷新", color: "warning" },
    adopted: { label: "已采纳", color: "success" },
    accepted_as_is: { label: "已原样采纳", color: "success" },
    accepted_with_changes: { label: "已修改采纳", color: "success" },
    partial_accept: { label: "已局部采纳", color: "warning" },
    closed_resolved: { label: "已采纳", color: "success" },
    rejected: { label: "已驳回", color: "error" },
    ignored: { label: "已放弃", color: "default" },
    manual_resolution: { label: "人工处理", color: "blue" },
    partially_applied: { label: "部分生效", color: "warning" },
    application_failed: { label: "应用失败", color: "error" },
    precondition_failed: { label: "事实变化", color: "warning" },
    stale: { label: "当前事实已变化", color: "warning" },
    superseded: { label: "已有更新判断", color: "default" },
    auto_adopted: { label: "已自动采纳", color: "success" },
};

const DECISION_RESULT_STATUS_LANGUAGE = {
    applied: "已生效",
    matched: "已对账",
    applied_as_expected: "已按提案生效",
    applied_with_user_changes: "已按修改生效",
    applied_to_form: "已写入表单",
    not_applied: "未应用",
    partially_applied: "部分生效",
    application_failed: "应用失败",
    precondition_failed: "事实变化",
    domain_normalized: "已按领域规则规范化",
    resolved_by_manual_action: "已由人工处理",
    stale: "判断已过期",
    rejected: "已驳回",
    requested: "已提交",
    pending_apply_authorization: "等待应用授权",
    succeeded: "已完成",
    completed: "已完成",
    failed: "应用失败",
    partially_succeeded: "部分完成",
    under_review: "等待应用授权",
    needs_rebase: "需刷新",
    adopted: "已采纳",
    accepted_as_is: "已原样采纳",
    accepted_with_changes: "已修改采纳",
    partial_accept: "已局部采纳",
    closed_resolved: "已采纳",
    ignored: "已放弃",
    manual_resolution: "人工处理",
    superseded: "已有更新判断",
    auto_adopted: "已自动采纳",
};

function normalizeStatusKey(value) {
    if (value === null || value === undefined) return "";
    return String(value).replace(/\s+/g, " ").trim().toLowerCase();
}

export function getReviewStatus(status) {
    const key = normalizeStatusKey(status);
    return REVIEW_STATUS_LANGUAGE[key] || null;
}

export function mapDecisionResultStatus(status) {
    const key = normalizeStatusKey(status);
    return DECISION_RESULT_STATUS_LANGUAGE[key] || null;
}
